export default {
    appParams: {
        thisActionDeleteParam: "This action will remove this parameter:",
        continue: "Continue",
        cancel: "Cancel"
    },
    bases: {
        selectActionWithBase: "Select action with base:",
        quanityOfTetheredApps: "Number of bound applications:",
        selectAppsFromWhichUntieBase: "Select applications from which to unbind the base:",
        untieBaseOfSelectedApps: "Untie base from selected applications",
        noAppsAttachedToBase: "There are no applications attached to this database",
        deleteBase: "Delete base",
        cancel: "Cancel",
        thisActionDeleteBaseWholly: "This action will completely remove the base, unbinding it from all applications. Continue?",
        cancellation: "Cancel",
        selectAppForUntie: "Select an application to untie",
        selectOperation: "Select an operation"
    },
    roles: {
        thisActionDeleteThisRole: "This action will remove this role:",
        continue: "Continue",
        cancellation: "Cancel",
    },
    sections: {
        selectAction: "Select action with application:",
        numberOfLinkedBases: "Number of linked bases",
        selectBasesToUntie: "Select bases to untie from the application",
        noUntiedBasesToThisApp: "There are no bases attached to this application",
        deleteApp: "Delete application",
        cancel: "Cancel",
        thisActionDeleteAppWholly: "This action will completely remove the application, unlinking all bases and deleting cron packets",
        basesAndPackets: "Bases linked: {bases}, used in {packets} packets",
        continue: "Continue",
        cancellation: "Cancel",
        selectAppForUntie: "Select an application to untie",
        selectOption: "Select an operation",
        selectAllBases: "Select all bases",
        unselectAllBases: "Unselect all bases",
        untieSelectedBasesFromApp: "Untie selected bases from the application"
    },
    servers: {
        versions: "Versions",
        hardwareInfo: "Resource control",
        mainAgentVersion: "Main agent version",
        tinyAgentsVersions: "Tiny Agent Versions",
        thisActionDeleteServer: "This action will delete this server",
        continue: "Continue",
        attention: "Attention",
        cancellation: "Cancel"
    },
    users: {
        errorYouCantDeleteDeveloper: "Error. Unable to delete system developer",
        actionDeleteThisUser: "This action will delete this user",
        continue: "Continue",
        cancellation: "Cancel"
    }
};